import { render, staticRenderFns } from "./EditAddress.vue?vue&type=template&id=3f192a58&scoped=true"
import script from "./EditAddress.vue?vue&type=script&lang=js"
export * from "./EditAddress.vue?vue&type=script&lang=js"
import style0 from "./EditAddress.vue?vue&type=style&index=0&id=3f192a58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f192a58",
  null
  
)

export default component.exports